import { Component, Input } from '@angular/core';


@Component({
  selector: 'app-track-information',
  templateUrl: './track-information.component.html',
  styleUrls: ['./track-information.component.scss']

})
export class TrackInformationComponent {
  @Input() serviceName: string;
  @Input() resourceName: string;
  @Input() showQueueInfo = true;
  @Input() ticketPosition: string;
  @Input() prevision: string;
  @Input() ticketCode: string;
  // Quando true, a previsao de atendimento nao é exibida (ver environment.hidePrevisionProviderIds).
  @Input() disablePrevision = false;
}
